<script>
    import appConfig from "@/app.config";

    export default {
        name: "app",
        page: {
            // All subcomponent titles will be injected into this template.
            titleTemplate(title) {
                title = typeof title === "function" ? title(this.$store) : title;
                return title ? `${title} | ${appConfig.title}` : appConfig.title;
            }
        },
        created: function () {

            this.$http.interceptors.response.use(response => {
                return response;
            }, error => {
                if (error.response.status === 401 && this.$router.currentRoute.name != 'login') {
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: "You have been logged out.",
                        confirmButtonText: 'Please Login Again'
                    }).then((result) => {
                        this.$store.dispatch('logout');
                        this.$store.dispatch('memberLogout').then(() => window.location = '/');
                    });
                } else {
                    // Forward responsibility to the function that made the call.
                    return Promise.reject(error);
                }
            });
        }
    };
</script>

<template>
    <div id="app">
        <RouterView :key="$route.path" />
    </div>
</template>

<style>
    .slide-enter-active,
    .slide-leave-active {
        transition: opacity 1s, transform 1s;
    }
    .slide-enter,
    .slide-leave-to {
        opacity: 0;
        transform: translateX(-30%);
    }
    .moveUp-enter-active {
        animation: fadeIn 1s ease-in;
    }
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }
    .moveUp-leave-active {
        animation: moveUp 0.3s ease-in;
    }
    @keyframes moveUp {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: translateY(-400px);
        }
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.6s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
